import { ItemsInner } from "@nens/rana/api-v1";
import { Schematisation } from "@nens/threedi/openapi-client";

import { ProjectFile } from "@/types/api-model-simple-names";

// Checks if a model schema is from the catalogue based on its revision_id
// If the revision_id is null, it means the model schema is FROM the catalogue.
// From meaning, it's been added to a project but we are not currently looking at the catalogue version of it.
export const modelSchemaIsFromCatalogue = (schematisation: Schematisation) => {
  return !schematisation.ranaProjectId;
};

export const modelSchemaFileIsFromCatalogue = (file: ProjectFile | ItemsInner) => {
  return file.descriptor?.meta?.revision_id === null;
};
